<div class="loader-container">
  <span class="label">{{ label }}</span>
  <div class="dots">
    <span></span>
    <span></span>
    <span></span>
  </div>
</div>